import React from 'react';
import './Grid.scss';

const Grid = ({ grid, onSlotClick, onDelete }) => {
  return (
    <div className="grid">
      {grid.map((row, rowIndex) => (
        <div key={rowIndex} className="row">
          {row.map((slot, colIndex) => (
            <div
              key={colIndex}
              className={`slot ${slot ? "filled" : "empty"}`}
              onClick={() => !slot && onSlotClick(rowIndex, colIndex)}
            >
              {slot && (
                <div className="medicamento-content">
                  <div className="medicamento-info">
                    <span className="nome">{slot.nome}</span>
                    <button 
                      className="delete-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(slot.id);
                      }}
                    >
                      ×
                    </button>
                  </div>
                  <div className="medicamento-details">
                    <span>{slot.dosagem}</span>
                    <span className="frequencia">{slot.frequencia}</span>
                  </div>
                </div>
              )}
              {!slot && (
                <div className="empty-slot-content">
                  <div className="empty-icon">+</div>
                  <div className="empty-text">
                    <span>Adicionar</span>
                    <span>Medicamento</span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Grid;